import { EntityService } from '../../service/EntityService';
import { i18n } from '../../shared/language';

export class InvoiceService extends EntityService {

  static entity = 'app/invoice';

  static getListInvoiceSign(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/invoice-sign`, { params }).then(res => res.data);
  }

  static getEligibleForInvoiceList(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/eligible-for-invoice-list`, { params }).then(res => res.data);
  }

  static getPaymentTypes(): Promise<any> {
    return this.axios.get(`app/payment-type`, { params: { maxResultCount: 1000, Sorting: 'code', SortType: 'ASC' } }).then(res => res.data);
  }

  static deleteBatch(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/mutile-delete`, data).then(res => res.data);
  }

  static downloadInvoiceExcel(registerInvoiceId: string): Promise<any> {
    return this.axios.get(`${this.entity}/file-excel/${registerInvoiceId}`, { responseType: 'blob' }).then(res => res.data);
  }

  static uploadInvoiceExcel(registerInvoiceId: string, data: any): Promise<any> {
    return this.axios.post(`${this.entity}/upload/${registerInvoiceId}`, data).then(res => res.data);
  }

  static downloadInvoicePdf(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/downloaf-pdf`, { responseType: 'blob' }).then(res => res.data);
  }

  static printViewDraft(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/print-view-draft-html`, data).then(res => res.data);
  }

  static downloadInvoiceXml(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/download-xml/${id}`, { responseType: 'blob' }).then(res => res.data);
  }

  static printViewHtml(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/print-view-html`).then(res => res.data);
  }

  static printMultiHtml(data: any): Promise<any> {
    // return this.axios.post(`${this.entity}/${id}/print-view-html`).then(res => res.data);
    return this.axios.post(`${this.entity}/print-multi-html`, data).then(res => res.data);
  }

  static printViewSwitchHtml(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/print-view-swich-html`).then(res => res.data);
  }

  static getParentInvoice(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/parent-invoice`).then(res => res.data);
  }

  static getListSubstitutes(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/invoices-substitute`, { params }).then(res => res.data);
  }

  static getSubstitute(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/substitute-invoice`).then(res => res.data);
  }

  static createSubstitute(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/substitute`, data).then(res => res.data);
  }

  static updateSubstitute(id: string, data: any): Promise<any> {
    return this.axios.put(`${this.entity}/${id}/substitute`, data).then(res => res.data);
  }

  static getListAdjustments(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/invoices-adjustment`, { params }).then(res => res.data);
  }

  static getAdjustment(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/adjustment-invoice`).then(res => res.data);
  }

  static createAdjustment(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/adjustment`, data).then(res => res.data);
  }

  static updateAdjustment(id: string, data: any): Promise<any> {
    return this.axios.put(`${this.entity}/${id}/adjustment`, data).then(res => res.data);
  }

  static getListCancels(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/invoices-cancel`, { params }).then(res => res.data);
  }

  static downloadExcelDetail(registerInvoiceId: string): Promise<any> {
    return this.axios.get(`${this.entity}/file-excel-detail/${registerInvoiceId}`, { responseType: 'blob' }).then(res => res.data);
  }

  static uploadExcelDetail(registerInvoiceId: string, data: any): Promise<any> {
    return this.axios.post(`${this.entity}/upload-detail/${registerInvoiceId}`, data).then(res => res.data);
  }

  static createSyncInvoice(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/sync-invoice`, data).then(res => res.data);
  }

  static createChangeSerial(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/change-serial`, data).then(res => res.data);
  }

  static getTaxAuthStatus(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/status-on-tax-authority`, data).then(res => res.data);
  }

  static setTaxAuthStatus(data: any): Promise<any> {
    return this.axios.put(`${this.entity}/status-on-tax-authority`, data).then(res => res.data);
  }
  static updateBatchCompany(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/replace-company-info`, data).then(res => res.data);
  }

  static createAdjustmentList(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/adjustment-list`, data).then(res => res.data);
  }

  static createSubstituteList(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/substitute-list`, data).then(res => res.data);
  }
  static getInvoiceListItem(ids: any[]): Promise<any> {
    return this.axios.post(`${this.entity}/invoice-list-item`, {
      invoiceIds: ids,
    })
      .then(res => res.data);
  }
  static documentType_Cancel = 1;
  static documentType_Adjust = 2;
  static documentType_Substitute = 3;

  static requiresOwnPayment(invoiceStatus?: number): boolean {
    return (
      invoiceStatus === this.documentType_Adjust ||
      invoiceStatus === this.documentType_Substitute
    );
  }

  static resolveIsPaymented(
    invoice: { invoiceStatus?: number; isPaymented?: boolean },
    polledCompleted?: boolean,
  ): boolean {
    if (this.requiresOwnPayment(invoice.invoiceStatus)) {
      return Boolean(polledCompleted);
    }

    return Boolean(invoice.isPaymented) || Boolean(polledCompleted);
  }

  static displayIsPaymented(invoice: {
    invoiceStatus?: number;
    isPaymented?: boolean;
  }): boolean {
    if (this.requiresOwnPayment(invoice.invoiceStatus)) {
      return false;
    }

    return Boolean(invoice.isPaymented);
  }

  static readonly DEFAULT_PAYMENT_FIELDS = {
    isPaymented: false,
    paidAmount: 0,
    paymentTime: null,
    paymentStatus: null,
    transactionId: null,
  } as const;

  static applyDefaultPaymentFields<T extends Record<string, unknown>>(
    target: T,
  ): T {
    return {
      ...target,
      ...InvoiceService.DEFAULT_PAYMENT_FIELDS,
    };
  }

  static sendTaxStatuses = [
    { value: 0, translationKey: 'common.statusWaitingApproval' },
    { value: 1, translationKey: 'common.statusWaitingSignature' },
    { value: 6, translationKey: 'common.statusSigning' },
    { value: 2, translationKey: 'common.statusSigned' },
    { value: 3, translationKey: 'common.statusSending' },
    { value: 4, translationKey: 'common.statusSuccessful' },
    { value: 5, translationKey: 'common.statusFailed' }
  ];

  static invoiceStatuses = [
    { value: 0, translationKey: 'common.original' },
    { value: 1, translationKey: 'common.cancel' },
    { value: 2, translationKey: 'common.statusAdjustment' },
    { value: 3, translationKey: 'common.statusReplacement' },
    { value: 4, translationKey: 'common.statusExplanation' },
    { value: 5, translationKey: 'common.statusAdjusted' },
    { value: 6, translationKey: 'common.statusReplaced' }
  ];

  static itemProperties = [
    { value: 1, translationKey: 'common.itemGoodsService', multiplier: 1 },
    { value: 2, translationKey: 'common.itemPromotion', multiplier: -1 },
    { value: 3, translationKey: 'common.itemCommercialDiscount', multiplier: 0 },
    { value: 4, translationKey: 'common.itemDescription', multiplier: 0 },
    { value: 5, translationKey: 'common.itemSpecialGoods', multiplier: 1 }
  ];

  static getOptionLabel = (options: Array<{ value: number; translationKey?: string; label?: string }>, value: number) => {
    const option = options.find((item) => item.value === value);
    return option?.translationKey ? i18n.t(option.translationKey) : option?.label || '';
  };

  static getInvoiceStatusLabel = (value: number) =>
    InvoiceService.getOptionLabel(InvoiceService.invoiceStatuses, value);

  static getSendTaxStatusLabel = (value: number) =>
    InvoiceService.getOptionLabel(InvoiceService.sendTaxStatuses, value);

}
